// @flow

import { css } from 'styled-components';
import linkCss from '../../link/css';
import type { Theme } from '../../../types/theme';

const variant = (headerColor: string, bodyColor: string) => css`
  /* stylelint-disable no-descending-specificity */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${bodyColor};
    &:first-child {
      color: ${headerColor};
    }
  }

  *:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
    &+h1,
    &+h2,
    &+h3,
    &+h4,
    &+h5,
    &+h6 {
      color: ${headerColor};
    }
  }
  /* stylelint-enable no-descending-specificity */

  .content {
    color: ${bodyColor};
  }

  a {
    ${linkCss};
  }
`;

const primaryDark = (theme: Theme) => css`
  ${variant(theme.wysiwyg.primary, theme.wysiwyg.dark)}
`;

const primaryLight = (theme: Theme) => css`
  ${variant(theme.wysiwyg.primary, theme.wysiwyg.white)}
`;

const primaryPrimary = (theme: Theme) => css`
  ${variant(theme.wysiwyg.primary, theme.wysiwyg.primary)}
`;

const lightLight = (theme: Theme) => css`
  ${variant(theme.wysiwyg.white, theme.wysiwyg.white)}
`;

const lightDark = (theme: Theme) => css`
  ${variant(theme.wysiwyg.white, theme.wysiwyg.dark)}
`;

const lightPrimary = (theme: Theme) => css`
  ${variant(theme.wysiwyg.white, theme.wysiwyg.primary)}
`;

const darkLight = (theme: Theme) => css`
  ${variant(theme.wysiwyg.dark, theme.wysiwyg.white)}
`;

const darkDark = (theme: Theme) => css`
  ${variant(theme.wysiwyg.dark, theme.wysiwyg.dark)}
`;

const darkPrimary = (theme: Theme) => css`
  ${variant(theme.wysiwyg.dark, theme.wysiwyg.primary)}
`;

export default (themeVariant: string, theme: Theme) => {
  switch (themeVariant) {
    case 'primary_dark':
      return primaryDark(theme);
    case 'primary_light':
      return primaryLight(theme);
    case 'primary_primary':
      return primaryPrimary(theme);
    case 'light_light':
      return lightLight(theme);
    case 'light_dark':
      return lightDark(theme);
    case 'light_primary':
      return lightPrimary(theme);
    case 'dark_light':
      return darkLight(theme);
    case 'dark_dark':
      return darkDark(theme);
    case 'dark_primary':
      return darkPrimary(theme);
    default:
      return '';
  }
};
